(function () {
  const PRICE_SELECTOR = 'price-list';
  const PRELOAD_NEXT = 10;
  const DEBUG = false;

  let forceShowCompare = false;

  // --- Welche Währung soll angezeigt werden? (nur fürs SYMBOL)
  function getDesiredCurrencyByMarket() {
    // Bevorzugt Markets/Country
    const cc = (window.Shopify?.country || '').toUpperCase();
    const map = {
      CH: 'CHF',
      DE: 'EUR',
      AT: 'EUR',
      NL: 'EUR',
      BE: 'EUR',
      LU: 'EUR',
      FR: 'EUR',
      IT: 'EUR',
      ES: 'EUR',
      PT: 'EUR',
      IE: 'EUR',
      US: 'USD',
      GB: 'GBP',
      DK: 'DKK',
      NO: 'NOK',
      SE: 'SEK',
      PL: 'PLN',
      CZ: 'CZK'
    };
    if (cc && map[cc]) return map[cc];

    // Fallback Shopify.currency.active, falls gesetzt
    if (window.Shopify?.currency?.active) return Shopify.currency.active;

    // Meta-Fallback
    const meta = document.querySelector('meta[name="currency"]')?.getAttribute('content');
    if (meta) return meta.toUpperCase();

    return 'EUR';
  }

  const SYMBOL_BY_CURRENCY = {
    EUR: '€',
    USD: '$',
    GBP: '£',
    CHF: 'CHF', // ja, in CH oft „CHF“ statt „Fr.“
    DKK: 'kr',
    NOK: 'kr',
    SEK: 'kr',
    PLN: 'zł',
    CZK: 'Kč'
  };

  // Entfernt vorhandene Symbole/Codes und injiziert das „richtige“ Symbol,
  // ohne die Zahlendarstellung (Komma/Punkt/Spacing) kaputtzumachen.
  function coerceCurrencySymbol(formattedText, desiredCurrency) {
    if (formattedText == null) return formattedText;
    const sym = SYMBOL_BY_CURRENCY[desiredCurrency] || desiredCurrency;
    let s = String(formattedText);

    // Strip gängige Symbole/Codes am Anfang/Ende, inkl. Spacing
    // Beispiele: "€ 19,99", "19,99 €", "CHF 19.99", "19.99 CHF", "$19.99"
    const known = [
      '€', '\\$','£','CHF','DKK','NOK','SEK','PLN','CZK','zł','Kč','kr'
    ];
    const startRe = new RegExp(`^\\s*(?:${known.join('|')})\\s*`);
    const endRe = new RegExp(`\\s*(?:${known.join('|')})\\s*$`);
    s = s.replace(startRe, '').replace(endRe, '').trim();

    // Positionierung: einbuchstabige Symbole als Suffix (19,99 €), mehrbuchstabige als Präfix (CHF 19.99)
    if (sym.length === 1) {
      // Suffix, mit geschütztem Space wenn möglich
      return `${s}\u00A0${sym}`;
    } else {
      // Präfix
      return `${sym}\u00A0${s}`;
    }
  }

  // Shopify-typische Rundung
  const roundShopify = (value) => Math.round(value * 100) / 100;

  // Übersetzung für "ab" / "from"
  function getFromText() {
    const locale = window.Shopify?.locale || 'de';
    const translations = {
      'de': 'ab',
      'en': 'from',
      'fr': 'à partir de',
      'es': 'desde',
      'it': 'da',
      'nl': 'vanaf',
      'pl': 'od',
      'cs': 'od',
      'pt': 'a partir de'
    };
    return translations[locale] || translations['de'];
  }

  const FAILSAFE_MS = 5000;

  // Returns true only when the currently active discount code has the
  // `show_5_extra` flag (e.g. Influencer codes that grant 5% Extra on top).
  // Returns false for regular discount codes and when no code is active.
  function isFiveExtraActive() {
    try {
      const config = window.RosentalDiscount?.getCartConfiguration?.();
      return !!(config?.activeCode && config?.activeDiscount?.show_5_extra);
    } catch (e) {
      return false;
    }
  }

  // Mirrors `isFiveExtraActive()` as a body class so that purely CSS-driven UI
  // (e.g. line-item-tooltip split variant) can toggle on/off without per-element JS.
  function updateBodyExtraClass() {
    document.body.classList.toggle('has-5-extra-discount', isFiveExtraActive());
  }

  // Minimal HTML escaper for inserting the active discount code into innerHTML.
  // Codes are user/admin-controlled but should always be safe to render.
  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Renders the "+ 5% Extra Rabatt"-Hint below the price block when an active
  // discount code has the `show_5_extra` flag set. Element is rendered server-side
  // by snippets/price-list.liquid (only for product context).
  function updateSavingsExtraInfo(el, context) {
    const extraEl = el.querySelector('[data-savings-extra-info]');
    if (!extraEl) return;
    if (context !== 'product' || !isFiveExtraActive()) {
      extraEl.style.display = 'none';
      extraEl.innerHTML = '';
      return;
    }

    // Pull the active code name so we can display it inside the perk message.
    var activeCode = '';
    try {
      activeCode = window.RosentalDiscount?.getCartConfiguration?.()?.activeCode || '';
    } catch (e) {
      activeCode = '';
    }
    var codeHtml = '<b>' + escapeHtml(activeCode) + '</b>';

    // Locale-aware copy is hardcoded here (DE default, EN fallback) so the
    // perk can ship without a roundtrip through the locale JSON files.
    var lang = (document.documentElement.lang || '').toLowerCase().split('-')[0];
    var perkHtml = lang === 'en'
      ? 'With your code ' + codeHtml + ' you\'ll get an additional <strong>5% EXTRA discount</strong> in the cart'
      : 'Mit deinem Code: ' + codeHtml + ' erhältst du im Warenkorb <strong>5% EXTRA Rabatt</strong>';

    extraEl.innerHTML =
      '<span class="savings-extra-info__icon" aria-hidden="true">' +
        '<svg class="icon icon__tag" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="14" height="14">' +
          '<path d="M11.304 1.446a1.75 1.75 0 0 1 1.58.478l-8.971 1m7.652.509L4.788 4.788l-1.355 6.777 9.521 9.52 8.132-8.13-9.521-9.522Zm-.261-1.987L3.742 2.958l7.562-1.512Zm1.58.478 9.793 9.793a1.75 1.75 0 0 1 0 2.474l-8.486 8.486a1.75 1.75 0 0 1-2.474 0l-9.793-9.793a1.75 1.75 0 0 1-.478-1.58l1.512-7.562a1 1 0 0 1 .784-.784" fill-rule="evenodd" clip-rule="evenodd"/>' +
          '<path d="M7.874 9a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z"/>' +
        '</svg>' +
      '</span>' +
      '<span class="savings-extra-info__text">' + perkHtml + '</span>';
    extraEl.style.display = 'inline-flex';
  }

  function fallbackFormatMoney(amountInCents) {
    if (amountInCents == null || isNaN(amountInCents)) return '';
    var eur = (amountInCents / 100).toFixed(2).replace('.', ',');
    return eur + '\u00A0€';
  }

  function forceRemoveAllSkeletons() {
    document.querySelectorAll('.price-skeleton').forEach(function (el) {
      el.classList.remove('price-skeleton');
    });
    document.querySelectorAll(PRICE_SELECTOR + ':not(.loaded)').forEach(function (el) {
      try { updatePriceListEl(el); } catch (e) { forceShowRawPrice(el); }
    });
  }

  function forceShowRawPrice(el) {
    if (!el) return;
    var priceEl = el.querySelector('[data-product-price] .price-amount');
    if (priceEl) {
      var raw = parseFloat(el.dataset.originalPrice || 0);
      priceEl.textContent = fallbackFormatMoney(raw);
      priceEl.classList.remove('price-skeleton');
    }
    var compareEl = el.querySelector('[data-compare-price]');
    if (compareEl) compareEl.classList.remove('price-skeleton');
    el.querySelectorAll('.price-skeleton').forEach(function (s) { s.classList.remove('price-skeleton'); });
    el.classList.add('loaded');
  }

  function updatePriceListEl(el) {
    if (!el || el.classList.contains('loaded')) return;

    const productId = parseInt(el.dataset.productId);
    const price = parseFloat(el.dataset.originalPrice || 0);
    const compare = parseFloat(el.dataset.compareAtPrice || 0); // UVP
    const bestPrice30d = parseFloat(el.dataset.bestPrice30d || 0); // 30-Tage Bestpreis
    const hasBestPriceMetafield = el.dataset.hasBestPriceMetafield === 'true';
    const isSet = el.dataset.isSet === 'true';
    const context = el.dataset.context || '';
    const hasPriceRange = el.dataset.hasPriceRange === 'true';
    const minVariantPrice = parseFloat(el.dataset.minVariantPrice || 0);
    const minVariantCompareAt = parseFloat(el.dataset.minVariantCompareAtPrice || 0);
    // Hide compare prices on PLP (card context) - never show on collection/listing pages
    const shouldHideCompareOnPLP = context === 'card';
    // Only hide compare prices for sets in card context, not on product pages
    const shouldHideCompareForSet = isSet && context === 'card';
    let collections = [];

    try {
      collections = JSON.parse(el.dataset.productCollections || '[]').map(String);
    } catch (e) {
      if (DEBUG) console.warn('[price-list] Invalid productCollections JSON', e);
    }

    const priceEl = el.querySelector('[data-product-price] .price-amount');
    const compareEl = el.querySelector('[data-compare-price]');
    // Code for AB-Test: RO-25-54
    const savingsElEuro = el.querySelector('[data-savings-amount][data-savings-variant="euro"]');
    const savingsElPercent = el.querySelector('[data-savings-amount][data-savings-variant="percent"]');
    if (!priceEl) return;

    // Skip discount code when subscription mode is active (price already includes sub discount)
    let tier = null;
    try {
      tier = el.dataset.subscriptionActive === 'true'
        ? null
        : window.RosentalDiscount?.findDiscountTier?.(productId, collections);
    } catch (e) { if (DEBUG) console.warn('[price-list] findDiscountTier failed', e); }
    const desiredCurrency = getDesiredCurrencyByMarket();

    const fmt = (amount) => {
      try {
        const base = window.RosentalDiscount?.formatMoney?.(amount) ?? amount;
        return coerceCurrencySymbol(base, desiredCurrency);
      } catch (e) {
        return fallbackFormatMoney(amount);
      }
    };

    if (!tier) {
      const displayPrice = (context === 'card' && hasPriceRange) 
        ? `${getFromText()} ${fmt(minVariantPrice)}` 
        : fmt(price);

      let showCompare = false;
      if (compareEl) {
        if (forceShowCompare && compare > price) {
          showCompare = true;
        } else if (!isSet && context === 'product' && compare > price && !shouldHideCompareForSet) {
          showCompare = true;

          if (hasBestPriceMetafield && bestPrice30d > 0) {
            const priceDiff = Math.abs(compare - bestPrice30d);
            if (priceDiff < 1) {
              showCompare = false;
            }
          }
        }

        if (showCompare) {
          compareEl.innerHTML = `<span class="sr-only">Original price</span>${fmt(compare)}`;
          compareEl.style.setProperty('display', '', 'important');
        } else {
          compareEl.style.setProperty('display', 'none', 'important');
        }
        compareEl.classList.remove('price-skeleton');
      }

      priceEl.textContent = displayPrice;
      priceEl.classList.remove('price-skeleton');
      if (showCompare) {
        priceEl.classList.add('price--reduced');
        priceEl.classList.remove('price--default');
      } else {
        priceEl.classList.add('price--default');
        priceEl.classList.remove('price--reduced');
      }

      // Berechne Savings gegen Bestpreis (30-Tage) wenn vorhanden, sonst gegen compare-at-price
      let referencePrice = 0;
      if (hasBestPriceMetafield && bestPrice30d > 0) {
        // Verwende Bestpreis als Referenz
        referencePrice = bestPrice30d;
      } else if (compare > price) {
        // Fallback: verwende compare-at-price wenn kein Bestpreis vorhanden
        referencePrice = compare;
      }

      const savings = referencePrice > 0 ? (referencePrice - price) : 0;
      const showSavings = referencePrice > 0 && savings > 0.01 && context === 'product';

      if (savingsElEuro) {
        if (showSavings) {
          savingsElEuro.innerHTML = `Du sparst:<span class="savings-amount__value">${fmt(savings)}</span>`;
          savingsElEuro.classList.remove('price-skeleton');
          savingsElEuro.style.display = '';
        } else {
          savingsElEuro.innerHTML = '';
          savingsElEuro.style.display = 'none';
          savingsElEuro.classList.remove('price-skeleton');
        }
      }

      if (savingsElPercent) {
        if (showSavings) {
          const percent = referencePrice > 0 ? Math.round(((referencePrice - price) / referencePrice) * 100) : 0;
          savingsElPercent.innerHTML = `Du sparst:<span class="savings-amount__value">${percent}%</span>`;
          savingsElPercent.classList.remove('price-skeleton');
          savingsElPercent.style.display = '';
        } else {
          savingsElPercent.innerHTML = '';
          savingsElPercent.style.display = 'none';
          savingsElPercent.classList.remove('price-skeleton');
        }
      }

      updateSavingsExtraInfo(el, context);

      el.classList.add('loaded');
      return;
    }

    // Rabattbasis bestimmen
    // Auf PDP verwenden wir nicht mehr compare-at-price, sondern nur noch price
    // Für Rabattberechnung: wenn applies_to_price true ist, verwende price, sonst compare (für Kompatibilität)
    let discountBase = compare;
    if (typeof tier.applies_to_price !== 'undefined') {
      const appliesToPrice =
        tier.applies_to_price === true ||
        tier.applies_to_price === 'true' ||
        tier.applies_to_price === 1 ||
        tier.applies_to_price === '1';
      discountBase = appliesToPrice ? price : compare;
    }

    let finalPrice = price;
    if (tier.type === 'percentage') {
      finalPrice = roundShopify(discountBase * (1 - tier.value / 100));
    } else if (tier.type === 'fixed') {
      // tier.value in Major Units, Werte bleiben wie bei dir
      finalPrice = roundShopify(Math.max(0, discountBase - tier.value));
    }

    // Bei Product Cards mit Preisspanne: "ab [discounted-min-price]"
    // Verwende EXAKT die gleiche Logik wie bei der normalen Preisberechnung
    let finalMinPrice = minVariantPrice;
    if (context === 'card' && hasPriceRange) {
      // Bestimme Rabattbasis für min-variant genau wie oben
      let minDiscountBase = minVariantCompareAt || minVariantPrice;
      if (typeof tier.applies_to_price !== 'undefined') {
        const appliesToPrice =
          tier.applies_to_price === true ||
          tier.applies_to_price === 'true' ||
          tier.applies_to_price === 1 ||
          tier.applies_to_price === '1';
        minDiscountBase = appliesToPrice ? minVariantPrice : (minVariantCompareAt || minVariantPrice);
      }
      
      if (tier.type === 'percentage') {
        finalMinPrice = roundShopify(minDiscountBase * (1 - tier.value / 100));
      } else if (tier.type === 'fixed') {
        finalMinPrice = roundShopify(Math.max(0, minDiscountBase - tier.value));
      }
    }

    // Zeige "ab [Preis]" bei Product Cards mit Preisspanne
    const displayPrice = (context === 'card' && hasPriceRange) 
      ? `${getFromText()} ${fmt(finalMinPrice)}` 
      : fmt(finalPrice);
    
    priceEl.textContent = displayPrice;
    priceEl.classList.add('price--reduced');
    priceEl.classList.remove('price--default', 'price-skeleton');

    if (compareEl) {
      const strikeThroughPrice = (compare > 0) ? compare : price;

      let showCompare = false;

      if (forceShowCompare && strikeThroughPrice > finalPrice) {
        showCompare = true;
      } else if (isSet && context === 'product') {
        showCompare = false;
      } else if (context === 'product' && strikeThroughPrice > finalPrice && !shouldHideCompareForSet) {
        showCompare = true;

        if (hasBestPriceMetafield && bestPrice30d > 0) {
          const priceDiff = Math.abs(strikeThroughPrice - bestPrice30d);
          if (priceDiff < 1) {
            showCompare = false;
          }
        }
      }

      if (showCompare) {
        compareEl.innerHTML = `<span class="sr-only">Original price</span>${fmt(strikeThroughPrice)}`;
        compareEl.style.setProperty('display', '', 'important');
      } else {
        compareEl.style.setProperty('display', 'none', 'important');
      }
      compareEl.classList.remove('price-skeleton');
    }

    // Berechne Savings gegen Bestpreis (30-Tage) wenn vorhanden, sonst gegen compare-at-price
    let referencePrice = 0;
    if (hasBestPriceMetafield && bestPrice30d > 0) {
      // Verwende Bestpreis als Referenz
      referencePrice = bestPrice30d;
    } else if (compare > finalPrice) {
      // Fallback: verwende compare-at-price wenn kein Bestpreis vorhanden
      referencePrice = compare;
    }

    const savings = referencePrice > 0 ? (referencePrice - finalPrice) : 0;
    const showSavings = referencePrice > 0 && savings > 0.01 && context === 'product';

    if (savingsElEuro) {
      if (showSavings) {
        savingsElEuro.innerHTML = `Du sparst:<span class="savings-amount__value">${fmt(savings)}</span>`;
        savingsElEuro.classList.remove('price-skeleton');
        savingsElEuro.style.display = '';
      } else {
        savingsElEuro.innerHTML = '';
        savingsElEuro.style.display = 'none';
        savingsElEuro.classList.remove('price-skeleton');
      }
    }

    if (savingsElPercent) {
      if (showSavings) {
        const percent = referencePrice > 0 ? Math.round(((referencePrice - finalPrice) / referencePrice) * 100) : 0;
        savingsElPercent.innerHTML = `Du sparst:<span class="savings-amount__value">${percent}%</span>`;
        savingsElPercent.classList.remove('price-skeleton');
        savingsElPercent.style.display = '';
      } else {
        savingsElPercent.innerHTML = '';
        savingsElPercent.style.display = 'none';
        savingsElPercent.classList.remove('price-skeleton');
      }
    }

    updateSavingsExtraInfo(el, context);

    el.classList.add('loaded');
  }

  function observePriceLists() {
    const allPriceLists = Array.from(document.querySelectorAll(`${PRICE_SELECTOR}:not(.loaded)`));
    const preloadNow = allPriceLists.slice(0, PRELOAD_NEXT);
    const lazyRest = allPriceLists.slice(PRELOAD_NEXT);

    preloadNow.forEach(updatePriceListEl);

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        updatePriceListEl(entry.target);
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.1 });

    lazyRest.forEach(el => observer.observe(el));
  }

  function observeDynamicPriceLists() {
    const mo = new MutationObserver((mutations) => {
      mutations.forEach(m => {
        m.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches?.(PRICE_SELECTOR)) updatePriceListEl(node);
          node.querySelectorAll?.(PRICE_SELECTOR).forEach(updatePriceListEl);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  // Warte bis euer BFF da ist, damit formatMoney existiert
  function waitForRosentalDiscount(callback, attempts = 0) {
    if (window.RosentalDiscount?.getCartConfiguration) {
      const config = window.RosentalDiscount.getCartConfiguration();
      if (config && config.cart) {
        callback();
        return;
      }
    }
    if (attempts < 10) {
      setTimeout(() => waitForRosentalDiscount(callback, attempts + 1), 100);
    } else {
      callback();
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    var failsafeTimer = setTimeout(forceRemoveAllSkeletons, FAILSAFE_MS);

    waitForRosentalDiscount(() => {
      clearTimeout(failsafeTimer);
      if (window.__showCompareAtPrices && !forceShowCompare) {
        forceShowCompare = true;
        document.body.classList.add('force-show-compare');
      }
      updateBodyExtraClass();
      observePriceLists();
      observeDynamicPriceLists();
    });
  });

  // Re-render bei Cart-Konfig-Update
  window.addEventListener('cart-config:update', () => {
    updateBodyExtraClass();
    document.querySelectorAll(`${PRICE_SELECTOR}.loaded`).forEach(el => el.classList.remove('loaded'));
    observePriceLists();
  });

  // Discount-Code wurde aktiviert/deaktiviert → Body-Klasse aktualisieren
  ['discount:applied', 'discount:removed', 'discount:change', 'cookie:discount:change']
    .forEach(evt => window.addEventListener(evt, updateBodyExtraClass));

  // Zentrales Event: compare-at-prices ein-/ausblenden
  window.addEventListener('price-list:show-compare', (event) => {
    const show = event.detail?.show !== false;
    if (forceShowCompare === show) return;
    forceShowCompare = show;
    document.body.classList.toggle('force-show-compare', show);
    document.querySelectorAll(`${PRICE_SELECTOR}`).forEach(el => {
      el.classList.remove('loaded');
      updatePriceListEl(el);
    });
  });

  // Varianten-Switch: Preise + isSet aktualisieren + neu rendern
  document.addEventListener('variant:change', (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;
    const formId = event.detail?.formId;
    const form = formId ? document.forms[formId] : null;
    let priceLists = [];
    if (form) {
      const container = form.closest('.product, .quick-buy, product-info, [data-product]') || form.closest('section');
      if (container) {
        priceLists = Array.from(container.querySelectorAll(PRICE_SELECTOR));
      }
    }
    if (priceLists.length === 0 && variant.product_id) {
      priceLists = Array.from(document.querySelectorAll(`${PRICE_SELECTOR}[data-product-id="${variant.product_id}"]`));
    }
    priceLists.forEach(el => {
      el.dataset.originalPrice = variant.price || 0;
      el.dataset.compareAtPrice = variant.compare_at_price || 0;

      // isSet aus vorberechneter Map (Metafields nicht im Event verfügbar)
      let newSetPrice = 0;
      try {
        const map = JSON.parse(el.dataset.variantSetMap || '{}');
        newSetPrice = map[String(variant.id)] || 0;
      } catch (e) {}
      const isProductSet = el.dataset.isProductSet === 'true';
      el.dataset.isSet = (isProductSet || newSetPrice > 0) ? 'true' : 'false';

      el.classList.remove('loaded');
      updatePriceListEl(el);
    });
  });
})();
